<template>
  <el-dialog :append-to-body="true" id="services-layer" title="正元签电子合同服务协议" :visible.sync="dialogVisible" width="506px" :center="true">
    <p>正元签电子合同服务协议（以下简称“本协议”）是由北京正元安服科技有限公司（以下简称“正元安服”或“我们”）与正元签电子合同用户签署的正元签电子合同服务协议，本协议具有合同效力，用户勾选确认后，本协议成立并生效。</p>
    <p>一、声明与承诺</p>
    <p>(一)本协议对与您的权益有或可能有重大关系的条款， 以及对由北京正元安服科技有限公司具有或可能具有免责或限制责任的条款用粗体斜体和下划线字予以标注，请您注意。</p>
    <p>您确认，在您注册成为正元签电子合同平台用户已接受本服务，或您以其他本公司允许的方式实际使用本服务前，您已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</p>
    <p>(二)您同意，本公司有权随时对本协议内容进行单方面的变更，并以在本网站公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。</p>
    <p>(三)您保证，在您同意接受本协议并注册成为正元签电子合同用户时，您已经具备相应的民事行为能力，或者您是在中国大陆地区依法设立并合法开展经营活动或其他业务的法定代表人或其他组织；本协议内容不受您所属国家或地区法律的排斥。在您注册成为正元签电子合同用户时或在此后任何时间不具备前述条件的，您应立即终止注册或停止使用本服务。您在使用正元签电子合同服务时，应自行判断对方是否是完全民事行为能力人，且确定他提供的信息和他本人对应，并自行决定是否与对方进行签约交易等，且您应自行承担与此相关的所有风险。本平台不承担因对方身份确认失误而造成的损失。</p>
    <p>(四)您保证，在您同意接受本协议并注册成为正元签电子合同用户时，即表示您认可使用正元签电子合同平台作为缔约（包括但不限于电子合同）方式，认可您在正元签电子合同平台上的所有操作都是您个人意愿的表示，认可您在正元签电子合同平台上签订的电子合同（或协议）和纸质合同（或协议）具备相同的效力，认可您在正元签电子合同平台上的电子签名和您的手写签名具备相同的效力。</p>
    <p>(五)您同意，就您使用正元签电子合同服务，本公司有权将您的身份信息及签约合同信息相应传输至电子认证服务机构（CA, Certificate Authority）或公证处，由CA以出具数字证书之目的或公证处以出具公证文件之目的使用并保存，且前述信息可以保存至数字证书失效后或相关电子数据（包括但不限于签约合同电子数据）产生后5年，并且该等信息不因您终止正元签电子合同服务而停止保存。</p>
    <p>(六)您同意，就您使用正元签电子合同服务，本公司有权将您的身份信息、证件复印件或扫描件相应传输至征信机构及其他服务提供商，由这类机构来验证签约方身份并保存。</p>
    <p>(七)您确认并知悉，正元签电子合同服务不适用于以下文件的签订：</p>
    <p>1.涉及婚姻、收养、继承等人身关系的；</p>
    <p>2.涉及停止供水、供热、供气、供电等公用事业服务的；</p>
    <p>3.法律、行政法规规定的不适用电子文书的其他情形。</p>
    <p>二、定义和解释</p>
    <p>(一)正元签电子合同账户（或“该账户”）：是本平台向您提供的唯一编号。您可自行为该正元签电子合同账户设置密码，并用以查询或发起代表您个人、公司或者组织的签约过程。您需使用本人电子邮箱或手机号码，或者本公司允许的其它方式，例如通过扫描二维码、识别生物特征的方式，作为登录手段登录正元签电子合同账户。</p>
    <p>(二)数据源：指合法持有您的身份信息并依法向本平台及相关供应商提供实名认证比对结果的主体，包括：</p>
    <p>1.依法运营政府部门数据库的主体，包括各级行政机关、政府部门、公共管理部门、司法机关、公共信用信息管理部门等主体；</p>
    <p>2.依法运营商业化数据库的主体，包括电信运营商、金融机构等企事业单位。具体以实际合作情况为准。</p>
    <p>(三)身份信息：指您的姓名、联系方式、营业执照、法定代表人、统一社会信用代码以及您有效证件的种类、号码和有效期限等能够依法识别您身份的信息。</p>
    <p>(四)CA机构：指获得《电子认证服务许可证》的第三方数字证书签发机构。</p>
    <p>(五)数字证书：指由第三方CA签发的，含有签发数字证书的电子认证服务机构名称、证书持有人名称、证书序列号、证书有效期、证书持有人的电子签名验证数据、电子认证服务机构的电子签名、工业和信息化部规定的其他内容的身份证明数据。</p>
    <p>三、正元签电子合同服务</p>
    <p>(一)正元签电子合同服务（以下简称为本服务）：指本条（二）所列的服务，及您实际使用的本公司或本公司接受您的委托为您不时提供的服务以及提供的其他服务。</p>
    <p>(二)正元签电子合同服务包括（但不限于）以下服务：</p>
    <p>1.电子协议服务</p>
    <p>通过“正元签电子合同”平台，本公司向注册用户提供在该平台上的电子协议发送，签署，接受，下载等服务。</p>
    <p>2.电子证据保存和公证服务</p>
    <p>本公司通过指定合作方公司提供所有在“正元签电子合同”平台上的电子交易证据保存服务和公证服务。若用户需要对交易过程中产生的协议进行公证，可以通过本平台提出申请，并和指定合作公司和公证机构签订协议（若需要），并支付指定公司及公证机构相关的服务费用。</p>
    <p>四、正元签电子合同账户</p>
    <p>(一)注册相关</p>
    <p>除本协议另有规定或相关产品另有规则外，您须在本网站及/或无线客户端注册并取得本公司提供给您的正元签电子合同账户，并且按照本公司要求提供相关信息完成激活后方可使用本服务。您同意：</p>
    <p>1.按照本公司要求准确提供并在取得该账户后及时更新您正确、最新及完整的身份信息及相关资料。若本公司有合理理由怀疑您提供的身份信息及相关资料错误、 不实、过时或不完整的，本公司有权暂停或终止向您提供部分或全部正元签电子合同服务。本公司对此不承担任何责任，您将承担因此产生的任何直接或间接支出。若因国家 法律法规、部门规章或监管机构的要求，本公司需要您补充提供任何相关资料时，如您不能及时配合提供，本公司有权暂停或终止向您提供部分或全部正元签电子合同服务。</p>
    <p>2.您应当准确提供并及时更新您提供的电子邮件地址、联系电话等联系方式，以便本公司与您进行及时、有效联系。您应完全独自承担因通过这些联系方式无法与您取得联系而导致的您在使用本服务过程中遭受的任何损失或增加任何费用等不利后果。您理解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按本公司的要求进行操作。</p>
    <p>3.您应及时更新资料（包括但不限于身份证、护照、营业执照等证件或其他身份证明文件、联系方式、作为正元签电子合同平台登录名的邮箱或手机号码、与正元签电子合同平台账户绑定的邮箱、手机号码等），否则我们有权将正元签电子合同登录名、账户绑定的邮箱、手机号码开放给其他用户注册或使用。因您未及时更新资料导致的一切后果，均应由您自行承担，该后果包括但不限于导致本服务无法提供或提供时发生任何错误、账户及账户内信息被别人盗用，且您不得将此作为取消交易、拒绝执行协议的理由。</p>
    <p>4.您确认，只有您本人可以使用您的正元签电子合同账户。在您决定不再使用该账户时，您应按照本条（四）的规定向本公司申请注销该账户。 您同意，若您丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决、生效的遗嘱等）或本公司认可的其他资料处置您正元签电子合同账户内的资料。</p>
    <p>5.您确认，本公司有权在必要时要求核对您的有效身份证件或其他必要文件，您应积极配合，否则本公司有权限制或停止向您提供部分或全部正元签电子合同服务：</p>
    <p>A、您要求变更身份信息或您身份信息已过有效期的；</p>
    <p>B、本公司认为您的交易行为或交易情况出现异常的；</p>
    <p>C、本公司认为您的身份资料存在疑点或本公司在向您提供服务的过程中认为您已经提供的身份资料存在疑点的；</p>
    <p>D、本公司认为应核对或留存您身份证件或其他必要文件的其他情形的。</p>
    <p>(二)账户安全</p>
    <p>您将对使用该账户或密码进行的一切操作及言论负完全的责任，您同意：</p>
    <p>1.除相关产品另有规则外，本公司可以通过您的正元签电子合同登录名和密码或扫描您的生物特征，您应当对该密码、身份信息等进行妥善保管，对于因密码、身份信息、校验码等泄露所致的损失由您自行承担。您保证不向其他任何人泄露您的正元签电子合同登录名及密码、校验码以及身份信息等，亦不使用其他任何人的正元签电子合同登录名及密码。本公司亦可能通过本服务应用您使用的其他产品或设备识别您的指示，您应当妥善保管处于您或应当处于您掌控下的这些产品或设备，对于这些产品或设备遗失所致的任何损失，由您自行承担。</p>
    <p>2.基于计算机端、手机端以及使用其他电子设备的用户使用习惯，我们可能在您使用具体产品时设置不同的账户登录模式及采取不同的措施识别您的身份。</p>
    <p>3.您同意：</p>
    <p>（a）如您发现有他人冒用或盗用您的正元签电子合同登录名及密码或任何其他未经合法授权之情形，或发生与正元签电子合同账户关联的手机或其他设备遗失或其他可能危及到正元签电子合同账户资金安全情形时，应立即以有效方式通知本公司，向本公司申请暂停相关服务，以保障您的合法权益；</p>
    <p>（b）确保您在持续登录正元签电子合同网站时段结束时，以正确步骤离开网站。本公司不能也不会对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及（或）所导致的您的损失不承担任何责任。</p>
    <p>4.除非您本人书面提出申请或者另有法律规定或经司法裁判，且征得本公司同意，否则您的正元签电子合同登录名及密码、正元签电子合同账户不得以任何方式转让、赠与或继承（相关的财产权益除外）。</p>
    <p>5.您使用本服务时同意并认可，可能系统问题造成本服务无法提供，对此本公司不承担任何责任。</p>
    <p>可能系统问题包括但不限于：</p>
    <p>1)本公司在本网站公告之系统停机维护期间。</p>
    <p>2)电信设备出现故障不能进行数据传输的。</p>
    <p>3)因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本公司系统障碍不能执行业务的。</p>
    <p>4)由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
    <p>6.您同意，基于运行和交易安全的需要，本公司可以暂时停止提供或者限制本服务部分功能，或提供新的功能，在任何功能减少、增加或者变化时，只要您仍然使用本服务，表示您仍然同意本协议或者变更后的协议。</p>
    <p>7.本公司有权了解您使用本公司产品或服务的真实交易背景及目的，您应如实提供本公司所需的真实、全面、准确的信息。如果本公司有合理理由怀疑您提供虚假交易信息的，本公司有权暂时或永久限制您所使用的产品或服务的部分或全部功能，并通过邮件或者站内信或客户端通知等方式通知您，您应及时予以关注。</p>
    <p>8.您同意，本公司有权按照包括但不限于公安机关、检察机关、法院、海关、税务机关等司法机关、行政机关、军事机关的要求对您的个人信息及在正元签电子合同的交易及账户等进行查询、冻结或其他操作</p>
    <p>(三)注销相关</p>
    <p>在需要终止使用本服务时，您可以申请注销您的正元签电子合同账户，您同意：</p>
    <p>1.您所申请注销的正元签电子合同账户应当是您依照本协议的约定注册并由本公司提供给您本人的账户。您应当依照本公司规定的程序进行正元签电子合同账户注销。</p>
    <p>2.正元签电子合同账户注销将导致本公司终止为您提供本服务，本协议约定的双方的权利义务终止（依本协议其他条款另行约定不得终止的或依其性质不能终止的除外），同时还可能对于该账户产生如下结果：</p>
    <p>A、任何您的交易信息都将无法查看；</p>
    <p>B、任何您的交易过程中产生的附属文档都将无法查看，您可以在注销之前进行保存。</p>
    <p>C、注销完成后，本公司无法对您之前留存下来的任何信息提供鉴权，公证等服务</p>
    <p>3.您可以通过人工的方式申请注销正元签电子合同平台账户。</p>
    <p>4.您申请注销的正元签电子合同账户应当处于正常状态，即您的正元签电子合同账户的账户信息和用户信息是最新、完整、正确的，且该账户可以使用所有正元签电子合同服务功能。账户信息或用户信息过时、缺失、不正确的账户或被暂停或终止提供服务的账户不能被申请注销。如您申请注销的账户有关联账户或子账户的，在该关联账户或子账户被注销前，该账户不得被注销。</p>
    <p>5.您申请注销的正元签电子合同账户应当不存在任何由于该账户被注销而导致的未了结的合同关系与其他基于该账户的存在而产生或维持的权利义务，及本公司认为注销该账户会由此产生未了结的权利义务而产生纠纷的情况。</p>
    <p>6.如果您申请注销的正元签电子合同账户一旦注销成功，将不再予以恢复。</p>
    <p>7.您理解并同意，如果您在正元签电子合同网站有欺诈、虚假交易、侵犯他人合法权益或其他严重违反正元签电子合同网站规则或者中华人民共和国法律的行为的，本公司有权注销您名下的全部或部分正元签电子合同登录名，您将不能再登录正元签电子合同网站，所有网站的服务将同时终止。</p>
    <p>五、正元签电子合同服务使用规则</p>
    <p>为有效保障您使用本服务时的合法权益，您理解并同意接受以下规则：</p>
    <p>(一)一旦您使用本服务，您即不可撤销地授权本公司在您及（或）您指定人符合指定条件或状态时，向您的合作伙伴发送签约邀请并执行对应的操作。</p>
    <p>(二)本公司通过以下方式接受来自您的指令：</p>
    <p>A、您在本网站或其他可使用本服务的网站或软件上通过以您的正元签电子合同账户名及密码或数字证书等安全产品登录正元签电子合同账户并依照本服务预设流程所修改或确认的交易状态或指令；</p>
    <p>B、您通过您注册时作为该账户名称或者与该账户绑定的手机或其他专属于您的通讯工具（以下合称该手机）号码向本公司发送的信息（短信或电话等）回复；</p>
    <p>C、您通过您注册时作为该账户名称或者与该账户名称绑定的其他硬件、终端、软件、代号、编码、代码、其他账户名等有形体或无形体向本公司发送的信息（如本方式所指有形体或无形体具备与该手机接受信息相同或类似的功能，以下第五条第（四）、（五）、（六）项和第六条第（三）项涉及该手机的条款同样适用于本方式）；</p>
    <p>D、通过识别您的人脸等生物特征；</p>
    <p>E、本公司与您约定或本公司认可的其他方式。无论您通过以上何种方式向本公司发出指令，都不可撤回或撤销，且成为本公司代理您支付或收取款项或进行其他操作的唯一指令，视为您本人的指令，您应当自己对本公司忠实执行上述指令产生的任何结果承担责任。本协议所称绑定，指您的正元签电子合同账户与本条上述所称有形体或无形体存在对应的关联关系，这种关联关系使得正元签电子合同服务的某些服务功能得以实现，且这种关联关系有时使得这些有形体或无形体能够作为本公司对您的正元签电子合同账户的识别和认定依据。</p>
    <p>(三)您确认，您在网站上的任何操作以及因为操作导致的结果都具备法律效力。</p>
    <p>(四)使用本服务即表示您同意接受本服务的相关规则。您了解并同意本公司有权单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示（或发送到该手机的短信或电话或客户端通知等）为准，您同意并遵照服务规则是您使用本服务的前提。</p>
    <p>(五)本公司会以站内状态通知（或发送到该手机的短信或电话等或客户端通知等）方式通知您交易进展情况以及提示您进行下一步的操作，但本公司不保证您能够收到或者及时收到该等通知，且不对此承担任何后果，因此，您应当及时查看该等通知并进行相关操作。因您没有及时查看和对交易状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，本公司不负任何责任。</p>
    <p>(六)本公司对您所交易的协议内容不提供任何形式的鉴定服务。除本协议另有规定外，如您与交易对方发生交易纠纷，您不可撤销地授权由本公司根据本协议及本网站上载明的各项规则进行处理。您为解决纠纷而支出的通讯费、文件复印费、鉴定费等均由您自行承担。</p>
    <p>(七)您应按照本公司的要求完善您的身份信息以最终达到实名， 否则您可能会受到部分功能限制。</p>
    <p>(八)本公司会将您的签约过程及产生的资料，严格按照法律法规或有权机关的监管要求进行管理；除本协议另有规定外，不作任何其他非您指示的用途。当您使用正元签电子合同服务，本公司有权将您的身份信息及签约合同信息相应传输至电子认证服务机构（CA, Certificate Authority）或公证处，由CA以出具数字证书之目的或公证处以出具公证文件之目的使用并保存，且前述信息可以保存至数字证书失效后或相关电子数据（包括但不限于签约合同电子数据）产生后5年，并且该等信息不因您终止正元签电子合同服务而停止保存。同时，本公司有权将您的身份信息、证件照片或扫描件相应传输至征信机构及其他具有国家认可资质的数据服务提供商，由该等机构以验证签约方身份之目的使用并保存。您和任何签约方知悉并保证：本公司是数据电文等法律文件的签订平台，而不是CA机构或者实名认证机构。因此，您或者任何签约方通过本平台协助您和任何签约方开展实名认证的，本公司不对实名结果承担法律责任。因实名和意愿性校验无效而导致签订的数据电文等法律文件被认定无效的，相关的法律责任概与本公司无关。但因本公司故意造成无效的除外。</p>
    <p>(九)本公司并非法律机构，因交易内容或者因为协议内容产生的纠纷，本公司不承担任何解决义务，您可以向符合中华人民共和国法律规定的相关单位寻求解决。</p>
    <p>(十)您不得将本服务用于非本公司许可的其他用途。</p>
    <p>(十一)签约风险</p>
    <p>1.在使用本服务时，若您或您的签约对方未遵从本服务条款或网站说明、交易页面中之操作提示、规则），则本公司有权拒绝为您与签约对方提供相关服务，且本公司不承担损害赔偿责任。</p>
    <p>2.因您的过错导致的任何损失由您自行承担，该过错包括但不限于：不按照提示操作，未及时进行操作，遗忘或泄漏密码、校验码等，密码被他人破解，您使用的计算机或其他硬件、终端等被他人侵入或丢失，或您使用的软件被他人侵入，或者您的生物特征被他人利用。</p>
    <p>3.当您和数据电文的签约方在签订数据电文等法律文件时，应当自行判定自己及其他当事人的主体资格是否合格。如果您和/或者其他当事人是无民事行为能力人或者限制民事行为能力人，不得签订或者仅能签订与自己的年龄、智力和精神健康状况相适应的法律文件。因主体不合格导致通过正元签电子合同平台签订的数据电文等法律文件无效的，责任和法律后果由您和该法律文件其他签约方自己承担。</p>
    <p>(十二)服务费用</p>
    <p>1.在您使用本服务时，本公司有权依照事先约定好的服务收费规则向您收取服务费用。本公司拥有制订及调整服务费之权利，具体服务费用以您使用本服务时本网站或客户端、产品页面上所列之收费方式公告或您与本公司达成的其他书面协议为准。</p>
    <p>2.除非另有说明或约定，您同意本公司有权在您委托本公司代收或代付的账户余额或者其他资产中直接扣除上述服务费用。</p>
    <p>(十三)您认可正元签电子合同平台账户的使用记录、交易状态等数据等均以本公司系统记录的数据为准。如您对该等数据存有异议的，应自您账户数据发生变动之日起15日内向本公司提出异议，并提供相关证据供本公司核实。</p>
    <p>六、正元签电子合同服务使用限制</p>
    <p>(一)您在使用本服务时应遵守中华人民共和国相关法律法规、您所在国家或地区之法令及相关国际惯例，不将本服务用于任何非法目的（包括用于禁止或限制交易物品的交易），也不以任何非法方式使用本服务。</p>
    <p>(二)您不得利用本服务从事侵害他人合法权益之行为，否则本公司有权拒绝提供本服务，且您应承担所有相关法律责任，因此导致本公司或本公司雇员或其他方受损的，您应承担赔偿责任。上述行为包括但不限于：</p>
    <p>1.侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益。</p>
    <p>2.违反依法定或约定之保密义务。</p>
    <p>3.冒用他人名义使用本服务。</p>
    <p>4.从事不法交易行为，如洗钱、恐怖融资、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、其他本公司认为不得使用本服务进行交易的物品等。</p>
    <p>5.提供赌博资讯或以任何方式引诱他人参与赌博。</p>
    <p>6.非法使用他人账户交易。</p>
    <p>7.进行与您或交易对方宣称的交易内容不符的交易， 或不真实的交易。</p>
    <p>8.从事任何可能含有电脑病毒或是可能侵害本服务系统、资料之行为。</p>
    <p>9.其他本公司有正当理由认为不适当之行为。</p>
    <p>您理解并同意，本公司不对因下述任一情况导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿（无论本公司是否已被告知该等损害赔偿的可能性）：</p>
    <p>1.本公司有权基于单方判断，包含但不限于本公司认为您已经违反本协议的明文规定及精神，对您名下的全部或部分正元签电子合同账户暂停、中断或终止向您提供本服务或其任何部分，并冻结、封存您的资料。</p>
    <p>2.本公司在发现异常交易或合理怀疑交易有疑义或有违反法律规定或本协议约定之虞时，有权不经通知先行暂停或终止您名下全部或部分正元签电子合同账户的使用（包括但不限于对这些账户名下的在途交易采取取消交易等限制措施），并拒绝您使用本服务之部 分或全部功能，并通过邮件或站内信或客户端通知等方式通知您，您应及时予以关注。</p>
    <p>3.您理解并同意，存在如下情形时，本公司有权对您名下正元签电子合同账户暂停或终止提供全部或部分正元签电子合同服务，且有权限制您所使用的产品或服务的部分或全部功能（包括但不限于对这些账户名下在途交易采取取消交易等限制措施），并通过邮件或站内信或者客户端通知等方式通知您，您应及时予以关注：</p>
    <p>1）根据本协议的约定：</p>
    <p>2）根据法律法规及法律文书的规定：</p>
    <p>3）根据有权机关的要求：</p>
    <p>4）您使用正元签电子合同服务的行为涉嫌违反国家法律法规及行政规定的：</p>
    <p>5）本公司基于单方面合理判断认为账户操作、资金进出等存在异常时：</p>
    <p>6）本公司依据自行合理判断认为可能产生风险的：</p>
    <p>7）您在参加市场活动时有批量注册账户、刷信用及其他舞弊等违反活动规则、违反诚实信用原则的：</p>
    <p>8）您遭到他人投诉，且对方已经提供了一定证据的：</p>
    <p>9）您可能错误地将他人账户进行了实名制或实名认证的。</p>
    <p>如您申请恢复服务、解除上述止付或限制，您应按本公司要求如实提供相关资料及您的身份证明以及本公司要求的其他信息或文件，以便本公司进行核实，且本公司 有权依照自行判断来决定是否同意您的申请。您应充分理解您的申请并不必然被允许。您拒绝如实提供相关资料及身份证明的，或未通过本公司审核的，则您确认本 公司有权长期对该等账户停止提供服务且长期限制该等产品或者服务的部分或全部功能。</p>
    <p>4.在本公司认为该等异常已经得到合理解释或有效证据支持或未违反国家相关法律法规及部门规章的情况下，最晚将于得到解释之日起的30个日历天内解除限制。但本公司有进一步理由相信该等异常仍可能对您或其他用户或本公司造成损失的情形除外，包括但不限于：</p>
    <p>1）收到针对该等异常的投诉；</p>
    <p>2）您已经实质性违反了本协议或另行签署的协议，且我们基于保护各方利益的需要必须继续止付款项或暂停执行指令；</p>
    <p>3）您虽未违反国家相关法律法规及部门规章规定，但该等使用涉及本公司限制合作的行业类目或商品，包括但不限于通过本公司的产品或服务从事类似金字塔或矩阵型的高额返利业务模式。</p>
    <p>5.在本公司合理认为有必要时，本公司无需事先通知即可终止提供本服务，并暂停、关闭或冻结、封存您名下全部或部分正元签电子合同账户及这些账户中所有相关资料及档案。</p>
    <p>(四)如您需要注销您的正元签电子合同账户，应先经本公司审核同意。本公司注销该账户，即表明本公司与您之间的协议已终止，但您仍应对您使用本服务期间的行为承担可能的违约或损害赔偿责任，同时本公司仍可保有您的相关信息</p>
    <p>七、系统中断或故障</p>
    <p>本公司系统因下列状况无法正常运作，使您无法使用各项服务时，本公司不承担损害赔偿责任，该状况包括但不限于：</p>
    <p>(一)本公司在本网站公告之系统停机维护期间。</p>
    <p>(二)电信设备出现故障不能进行数据传输的。</p>
    <p>(三)因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本公司系统障碍不能执行业务的。</p>
    <p>(四)由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
    <p>八、责任范围及责任限制</p>
    <p>(一)本公司仅对本协议中列明的责任承担范围负责。</p>
    <p>(二)您明确因交易所产生的任何风险应由您与交易对方承担。</p>
    <p>(三)本公司用户信息是由用户本人自行提供的，本公司无法保证该信息之准确、及时和完整，您应对您的判断承担全部责任。</p>
    <p>(四)本公司不对交易标的及本服务提供任何形式的保证，包括但不限于以下事项:</p>
    <p>1.本服务符合您的需求。</p>
    <p>2.本服务不受干扰、及时提供或免于出错。</p>
    <p>3.您经由本服务购买或取得之任何产品、服务、资讯或其他资料符合您的期望。</p>
    <p>(五)本服务之合作单位，所提供之服务品质及内容由该合作单位自行负责。</p>
    <p>(六)您经由本服务之使用下载或取得任何资料，应由您自行考量且自负风险，因资料之下载而导致您电脑系统之任何损坏或资料流失，您应负完全责任。</p>
    <p>(七)您自本公司及本公司工作人员或经由本服务取得之建议和资讯，无论其为书面或口头形式，均不构成本公司对本服务之保证。</p>
    <p>(八)在法律允许的情况下，本公司对于与本协议有关或由本协议引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、商誉 损失、使用数据或其他经济利益的损失），不论是如何产生的，也不论是由对本协议的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除本公司对上述损失的责任。</p>
    <p>(九)除本协议另有规定外，在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向您收取的当次服务费用总额。</p>
    <p>(十)您充分知晓并同意本公司可能同时为您及您的（交易）对手方提供本服务，您同意对本公司可能存在的该等行为予以明确豁免，并不得以此来主张本公司在提供本服务时存在法律上的瑕疵。</p>
    <p>(十一)除本协议另有规定或本公司另行同意外，您对本公司的委托及向本公司发出的指令均不可撤销。</p>
    <p>九、商标、知识产权、专利的保护</p>
    <p>(一)本公司及关联公司所有系统及本网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由本公司或本公司关联公司依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。</p>
    <p>(二)非经本公司或本公司关联企业书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。</p>
    <p>(三)尊重知识产权是您应尽的义务，如有违反， 您应承担损害赔偿责任。</p>
    <p>十、法律适用与管辖</p>
    <p>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并由被告住所地人民法院管辖。</p>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  }
}
</script>